import React from "react";
import { Table } from "hooks/useQuery/api-query";
import TherapyDataChangeLogTableRow from "./therapy-data-change-logs-row";

const TherapyDataChangeLogs = ({ rows, queryDispatcher, query, isFetching }) => {

  return (
    <div className="patients-table-tab" style={{padding:'1em'}}>
      <Table
        query={query}
        data={[rows]}
        queryDispatcher={queryDispatcher}
        isFetching={isFetching}
        containerClass="query-table patients-table dynamic-columns"
        customNotFoundMessage="No therapy data logs for this patient"
        columns={[
          {
            header: "Timestamp",
            field: "Timestamp",
            hasSort: false
          },
          {
            header: "Source",
            field: "Column Changed",
            hasSort: false
          },
          {
            header: "Previous Value",
            field: "PreviousValue",
            hasSort: false
          },
          {
            header: "New Value",
            field: "NewValue",
            hasSort: false
          },
          {
            header: "Updated By",
            field: "UpdatedBy",
            hasSort: false
          }
        ]}
        rows={rows}
        TableRow={
          row => <TherapyDataChangeLogTableRow {...row}/>
        }
        rowKey="Id"
        renderFooter={false}
        hasSort={false}
      />
    </div>
  );
};

export default TherapyDataChangeLogs;
